module.exports = __webpack_public_path__ + "static/img/about043.ca3b0a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about043.png
// module id = GM60
// module chunks = 1